<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img" [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>

<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
	<section class="container payment-monthly-subscription-container">
		<section class="dynamic-collapse">
			<section class="dynamic-collapse-header">
				<h2>Monthly Subscription</h2>
				<h3>Ex of 1st of each month</h3>
			</section>
			<form [formGroup]="paymentChosenForm" class="dynamic-collapse-main">
				<div class="dynamic-collapse-content">
					<div class="form-group">
						<input type="email" class="form-control" formControlName="email" id="paymentMonthlyInputEmail"
							   placeholder="email@email.com" required>
					</div>
					<div class="form-row">
						<div class="form-group col-12 col-md-6">
							<input type="text" class="form-control" formControlName="shortCode"
								   id="paymentMonthlySortCode" placeholder="12-34-56" required>
						</div>
						<div class="form-group col-12 col-md-6">
							<input type="text" class="form-control" formControlName="accountNumber" id="AccountNumber"
								   placeholder="12345678" required>
						</div>
					</div>
					<div class="form-group">
						<input type="text" class="form-control" formControlName="address"
							   id="paymentMonthlyInputAddress"
							   placeholder="Start typing your post code and choose from the list" required>
					</div>
					<div class="manually-address">
						<a [routerLink]="['/home']">Click here to enter your address manually</a>
					</div>
					<div class="form-group form-check">
						<label class="check-label">More than one person is required to authorise direct debits
							<input type="checkbox" checked="checked" class="form-check-input"
								   formControlName="acceptPolicy"
								   [ngClass]="{ 'is-invalid': submitted && f.acceptTerms.errors }">
							<span class="checkmark"></span>
						</label>
					</div>
					<div class="form-group set-up-btn">
						<input type="submit" class="btn btn-primary primary-default-btn payment-complete-btn"
							   (ngSubmit)="onSubmit()" value="Set up direct debit">
					</div>
				</div>
			</form>
		</section>
	</section>
</section>
